module.exports = __webpack_public_path__ + "img/eyebrow_male_straight_average_mask.e4d27aa2.png";